import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useGStatusStore = defineStore('gStatus', () => {
  // 首页对话框visible
  const dialogVisible = ref<boolean>(true);
  const updateDialogVisible = (visible: boolean) => {
    dialogVisible.value = visible;
  };

  // 是否为媒体信息（图片、视频）
  const isMedia = ref<boolean>(false);
  const updateIsMedia = (media: boolean) => {
    isMedia.value = media;
  };

  // 底部媒体、水印信息 buttomMenuBarVisible
  const buttomMenuBarVisible = ref<boolean>(false);
  const updateButtomMenuBarVisible = (media: boolean) => {
    buttomMenuBarVisible.value = media;
  };

  // ai是否在回答中...
  const isAnswering = ref<boolean>(false);
  const updateIsAnswering = (answering: boolean) => {
    isAnswering.value = answering;
  };

  // 提交的数据是否为数据分析(日报数据)
  const isDataAnalysis = ref<boolean>(false);
  const updateIsDataAnalysis = (dataAnalysis: boolean) => {
    isDataAnalysis.value = dataAnalysis;
  };

  // 思考模式
  const isSummary = ref<boolean>(false);
  const updateSummary = (summary: boolean) => {
    isSummary.value = summary;
  }


  // 开启录音
  const isRecording = ref<boolean>(false);
  const setIsRecording = (recording: boolean) => {
    isRecording.value = recording;
  };

  return {
    dialogVisible,
    updateDialogVisible,
    isMedia,
    updateIsMedia,
    buttomMenuBarVisible,
    updateButtomMenuBarVisible,
    isAnswering,
    updateIsAnswering,
    updateIsDataAnalysis,
    isDataAnalysis,
    isSummary,
    updateSummary,
    setIsRecording,
    isRecording
  }


});